import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { OrderList } from 'primereact/orderlist';
import { useGetMyFavoritesQuery, useDeleteFavoriteMutation, useReorderFavoritesMutation } from '../api';
import { useLanguage } from '../contexts/LanguageContext';
import { toastService } from '../utils/toastService';

const AppMenuFavorites = () => {
    const { th } = useLanguage();
    const { data: favorites = [], isLoading } = useGetMyFavoritesQuery();
    const [deleteFavorite] = useDeleteFavoriteMutation();
    const [reorderFavorites] = useReorderFavoritesMutation();

    const [items, setItems] = useState([]);

    useEffect(() => {
        setItems(favorites);
    }, [favorites]);

    const onReorder = async (event) => {
        const newOrder = event.value;
        setItems(newOrder);
        try {
            await reorderFavorites(newOrder.map((f) => f.id)).unwrap();
            toastService.success(th('favorites.reordered', { fallback: 'Sıralama güncellendi' }), th('common.success', { fallback: 'Başarılı' }));
        } catch (e) {
            // Hatalar base.js tarafından global toast ile gösteriliyor
        }
    };

    const onRemove = async (event, fav) => {
        event.preventDefault();
        event.stopPropagation();
        try {
            await deleteFavorite(fav.id).unwrap();
            toastService.success(th('favorites.removed', { fallback: 'Favorilerden kaldırıldı' }), th('common.success', { fallback: 'Başarılı' }));
        } catch (e) {
            // Hatalar base.js tarafından global toast ile gösteriliyor
        }
    };

    const itemTemplate = (fav) => {
        return (
            <Link to={fav.link} className="layout-favorite-item">
                <i className={fav.icon || 'pi pi-bookmark'}></i>
                <span className="layout-favorite-item-text">{th(fav.translationKey, { fallback: fav.title })}</span>
                <i
                    role="button"
                    tabIndex={0}
                    className="pi pi-star-fill layout-favorite-item-remove"
                    title={th('favorites.remove', { fallback: 'Favorilerden kaldır' })}
                    onClick={(e) => onRemove(e, fav)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') onRemove(e, fav);
                    }}
                ></i>
            </Link>
        );
    };

    return (
        <div className="layout-favorites">
            <div className="layout-menuitem-root-text layout-favorites-title">{th('favorites.title', { fallback: 'Favorilerim' })}</div>
            {!isLoading && items.length === 0 ? (
                <div className="layout-favorites-empty">{th('favorites.empty', { fallback: 'Henüz favori eklemediniz' })}</div>
            ) : (
                <OrderList value={items} onChange={onReorder} itemTemplate={itemTemplate} dragdrop dataKey="id" className="layout-favorites-list" />
            )}
        </div>
    );
};

export default AppMenuFavorites;
